import { connect } from 'react-redux';
import AddNewCoworker from './add-new-coworker';
import {setValidationErrors, clearValidationErrors} from 'redux/modules/validation-errors/index';
import {
  setClearingNumberSuppressError,
  setAccountNumberSuppressError,
  reset
} from 'redux/modules/bank-info';

function mapStateToProps (state) {
  return {
    bankInfo: state.bankInfo,
    validationErrors: state.validationError,
    taxkeys: state.taxkeys
  };
};

const mapDispatchToProps = {
  setValidationErrors,
  clearValidationErrors,
  setClearingNumberSuppressError,
  setAccountNumberSuppressError,
  resetBankInfo: reset
};

export default connect(mapStateToProps, mapDispatchToProps)(AddNewCoworker);



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/distribution/add-new-coworker-container.js
 **/